module.exports = __webpack_public_path__ + "td.97c1759b.svg";